/*global analytics*/
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import snapChatLogo from "../assets/img/snap-ghost-yellow.png";

export default class ShareSnapchat extends Component {
    constructor(props) {
        super(props);

        this.shareSnapButton = React.createRef();
        this.state = {
            meta: {
                site_name: "FFF - My Box",
                title: "Share My Box!"
            },
            shareButtonClicked: false
        }
      }

    handleClick = (e) => {
        // segment tracking on click
        analytics.track('Clicked Element', {
            element_name: 'Snapchat share'
        });
    }

    render(){
        return (
            <React.Fragment>
                <Helmet>
                    <meta content={this.state.meta.site_name} property="og:site_name" />
                    <meta content={this.state.meta.title} property="og:title" />
                    <meta content={window.location.protocol + "//plutus." + window.location.hostname + "/images/fff-sticker.png"} property="snapchat:sticker" /> 
                    <script src="https://sdk.snapkit.com/js/v1/create.js" id="snapkit-creative-kit-sdk"></script>
                </Helmet>
                <div 
                    className="smb__icon smb__icon--snapchat" 
                    title="Share to Snapchat"
                >
                    <div 
                        className="snapchat-creative-kit-share" 
                        ref={this.shareSnapButton}
                        onClick={this.handleClick}
                        data-size="small"
                        data-share-url={this.props.url}
                    >
                    </div>
                    <img 
                        src={snapChatLogo} 
                        alt="Snapchat ghost"
                        className="smb__snap-logo"
                    />
                </div>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareSnapchat/ShareSnapchat.js